export const environment = {
  version: '5.1.8 - 27/10/2026',                           //VERSION
  production: false,
  apiUrl: 'https://emetro-api.com'        //PRODUCCION
};